// eslint-disable-next-line import/no-extraneous-dependencies
import { convert } from 'html-to-text';

export default (html) => convert(html);
